export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    window.addEventListener('load', function() {
      let formFields = document.querySelectorAll('.form-field');

      formFields.forEach(element => {
        let formControl = element.querySelector('.wpcf7-form-control-wrap .wpcf7-form-control');

        if (formControl && formControl.classList.contains('wpcf7-not-valid')) {
          element.classList.add('required');
        } else {
          element.classList.remove('required');
        }
      });
    });

    console.log('Hello!');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/enquire-now.js